import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router";
import { Provider } from "react-redux";
import { store } from "./store";
import { I18nextProvider } from "react-i18next";
import "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));

// 🔇 Disable console logs in production
if (process.env.NODE_ENV === "production") {
    console.log = function () {};
}

/**
 * 🔐 Security Hardening Wrapper
 */
const SecurityWrapper = ({ children }) => {
    useEffect(() => {
        // 🚫 Run only in production
        if (process.env.NODE_ENV !== "production") return;

        /* ===============================
           1️⃣ Disable Right Click
        ================================ */
        const disableRightClick = (e) => e.preventDefault();

        /* ===============================
           2️⃣ Disable DevTools Shortcuts
        ================================ */
        const disableDevToolsShortcuts = (e) => {
            if (
                e.key === "F12" ||
                (e.ctrlKey &&
                    e.shiftKey &&
                    ["I", "J", "C"].includes(e.key)) ||
                (e.ctrlKey && e.key === "u")
            ) {
                e.preventDefault();
            }
        };

        /* ===============================
           3️⃣ Detect DevTools (Heuristic)
        ================================ */
        const threshold = 160;
        let devToolsOpen = false;

        const detectDevTools = () => {
            const widthGap = window.outerWidth - window.innerWidth;
            const heightGap = window.outerHeight - window.innerHeight;

            if (widthGap > threshold || heightGap > threshold) {
                if (!devToolsOpen) {
                    devToolsOpen = true;
                    // alert(
                    //     "Developer tools are disabled for security reasons."
                    // );
                }
            } else {
                devToolsOpen = false;
            }
        };

        document.addEventListener("contextmenu", disableRightClick);
        document.addEventListener("keydown", disableDevToolsShortcuts);

        const devToolsInterval = setInterval(detectDevTools, 1000);

        return () => {
            document.removeEventListener("contextmenu", disableRightClick);
            document.removeEventListener(
                "keydown",
                disableDevToolsShortcuts
            );
            clearInterval(devToolsInterval);
        };
    }, []);

    return children;
};

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <I18nextProvider>
                <BrowserRouter>
                    <SecurityWrapper>
                        <App />
                    </SecurityWrapper>
                </BrowserRouter>
            </I18nextProvider>
        </Provider>
    </React.StrictMode>
);

// Performance monitoring (optional)
reportWebVitals();
